<template>
    <div class="logic-selector">
        <v-radio-group
            v-model="currentValue"
            @change="onChange"
        >
            <v-radio
                name="radio"
                value="and"
            >
                <v-icon
                    class="rule-icon"
                    name="rule-and"
                />满足以下全部条件组
            </v-radio>
            <v-radio
                name="radio"
                value="or"
            >
                <v-icon
                    class="rule-icon"
                    name="rule-or"
                />满足以下任一条件组
            </v-radio>
        </v-radio-group>
    </div>
</template>

<script>
import { Icon } from 'vhtml-ui';

const req = require.context('./assets/icons', false, /[^.]+\.svg$/);
Icon.addSprites(req);

export default {
  name: 'LogicSelector',
  props: {
    // 传入值
    value: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      currentValue: this.value,
    };
  },

  watch: {
    value(newValue) {
      this.currentValue = newValue;
    },
  },

  created() {
    if (!this.currentValue) {
      const defaultValue = 'and';
      this.currentValue = defaultValue;
      this.onChange(defaultValue);
    }
  },

  methods: {
    onChange(value) {
      this.$emit('change', value);
    },
  },
};
</script>

<style lang="less">
@import '~@/common/common.less';

.logic-selector {
    position: relative;
    overflow: hidden;

    .rule-icon {
        vertical-align: -4px;
        margin-right: 5px;
    }

    .v-radio-group-item {
        padding: 0 30px 0 15px;
        height: 50px;
        line-height: 50px;
        border: 1px solid #dadee7;
        border-radius: 4px;

        &:hover {
            border-color: #aaa;
        }

        &.is-checked {
            border-color: #0067ed;
        }

        .v-radio__inner {
            display: none;
        }
    }
}

.logic-selector-list-pop {
    padding: 0;
}
</style>
